module.exports = __webpack_public_path__ + "img/favicon.dc9450dc.svg";